import type { EntityAdapter } from '@ngrx/entity';
import type { Action } from '@ngrx/store';
import type {
  CompletedEntityState,
} from 'app/store/completed-entity-state/completed-entity-state';
import type { ScheduledTaskOutput } from 'core/http/project/scheduled-tasks/scheduled-tasks.service';
import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  initialCompletedEntityState,
} from 'app/store/completed-entity-state/completed-entity-state';
import * as ScheduledTasksActions from './scheduled-tasks.actions';

export interface ScheduledTasksState extends CompletedEntityState<ScheduledTaskOutput> {}

const adapter: EntityAdapter<ScheduledTaskOutput> = createEntityAdapter<ScheduledTaskOutput>();

export const initialScheduledTasksState = adapter.getInitialState<ScheduledTasksState>(initialCompletedEntityState);

const reducer = createReducer(
  initialScheduledTasksState,
  on(ScheduledTasksActions.saveScheduledTasks, (state, { tasks }) => adapter.setAll(tasks, state)),
  on(ScheduledTasksActions.markScheduledTasksLoaded, state => ({ ...state, loaded: true })),
  on(ScheduledTasksActions.addScheduledTaskInStore, (state, { entity }) => adapter.addOne(entity, state)),
  on(ScheduledTasksActions.updateScheduledTaskInStore, (state, { update }) => adapter.updateOne(update, state)),
  on(ScheduledTasksActions.removeScheduledTaskFromStore, (state, { id }) => adapter.removeOne(id, state)),
  on(ScheduledTasksActions.setLoading, (state, { value }) => ({ ...state, loading: value })),
  on(ScheduledTasksActions.setError, (state, { value }) => ({ ...state, error: value })),
);

export function scheduledTasksReducer(state: ScheduledTasksState | undefined, action: Action): ScheduledTasksState {
  return reducer(state, action);
}

export const {
  selectAll,
  selectEntities,
} = adapter.getSelectors();
